/* eslint-disable max-len */
import { FilterAndSortField as AscOrderFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/aftersales_order/request/model/FilterAndSortField';
import { AftersalesOrderResponse } from '@1po/1po-bff-fe-spec/generated/aftersales_order/response/AftersalesOrderResponse';
import { ClaimItem } from '@1po/1po-bff-fe-spec/generated/claim/request/CreateOrderClaimRequest';
import { GetGarageClaimPageResponse } from '@1po/1po-bff-fe-spec/generated/claim/response/GetGarageClaimPageResponse';
import { FilterBy } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterBy';
import {
  ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_RESPONSE,
  ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_RESPONSE,
  CHECKOUT_ORDER_RESPONSE,
  GET_AFTERSALES_ORDER_LIST_RESPONSE,
  GET_CLAIM_ATTACHMENT_DOWNLOAD_URL_RESPONSE,
  GET_CLAIM_ATTACHMENT_UPLOAD_URL_RESPONSE,
  GET_CURRENT_DEPOSIT_RETURN_LIST_RESPONSE,
  GET_CURRENT_EXADIS_RETURN_LIST_RESPONSE,
  GET_EXTERNAL_ORDER_LIST_RESPONSE,
  GET_GARAGE_CLAIM_RESPONSE,
  GET_GARAGE_USERS_WITH_ORDER_RESPONSE,
  GET_MY_CLIENTS_ORDER_DETAIL_RESPONSE,
  GET_MY_CLIENTS_ORDER_LIST_RESPONSE,
  GET_ORDER_BY_ID_RESPONSE,
  GET_ORDER_LIST_RESPONSE,
  GET_VEHICLE_INFO_BY_VRN_ERROR,
  GET_VEHICLE_INFO_BY_VRN_RESPONSE,
  ORDER_STATUS_UPDATE_RESPONSE,
  RE_ADD_ORDERED_REFERENCES_TO_BASKET_RESPONSE,
  REMOVE_ITEMS_FROM_DEPOSIT_RETURN_LIST_RESPONSE,
  REMOVE_ITEMS_FROM_EXADIS_RETURN_LIST_RESPONSE,
  REQUEST_CLAIM_RESPONSE,
  SEND_CLAIM_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { WsResponse } from '@1po/1po-bff-fe-spec/generated/common/WsResponse';
import { DepositReturnListLine } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/model/DepositReturnListLine';
import { AddAscOrderItemToDepositReturnListRequest } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/request/AddAscOrderItemToDepositReturnListRequest';
import { RemoveItemsFromDepositReturnListResponse } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/response/RemoveItemsFromDepositReturnListResponse';
import { ExadisReturnListLine } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/model/ExadisReturnListLine';
import { AddAscOrderItemToExadisReturnListRequest } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/request/AddAscOrderItemToExadisReturnListRequest';
import { RemoveItemsFromExadisReturnListResponse } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/response/RemoveItemsFromExadisReturnListResponse';
import { MyClientsOrderDetailResponse } from '@1po/1po-bff-fe-spec/generated/my_clients_order/response/MyClientsOrderDetailResponse';
import { MyClientsOrderResponse } from '@1po/1po-bff-fe-spec/generated/my_clients_order/response/MyClientsOrderResponse';
import {
  CheckoutExternalBasketReference,
  CheckoutOtherSection,
  CheckoutVehicleReference,
} from '@1po/1po-bff-fe-spec/generated/order/request/CheckoutOrderRequest';
import { FilterAndSortField } from '@1po/1po-bff-fe-spec/generated/order/request/model/FilterAndSortField';
import {
  CheckoutOverallStatus,
  OrderCheckoutResult,
} from '@1po/1po-bff-fe-spec/generated/order/response/CheckoutOrderResponse';
import { OrderDeliveryType, OrderItem } from '@1po/1po-bff-fe-spec/generated/order/response/GetDealerOrderPageResponse';
import { UserWithOrder } from '@1po/1po-bff-fe-spec/generated/order/response/GetGarageUsersWithOrderResponse';
import { ExternalOrderItem } from '@1po/1po-bff-fe-spec/generated/order/response/model/ExternalOrderItem';
import { OrderStatusUpdateResponse } from '@1po/1po-bff-fe-spec/generated/order/response/OrderStatusUpdateResponse';
import { ReferenceToReturn } from '@1po/1po-bff-fe-spec/generated/order/response/ReturnEmailResponse';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment/moment';
import { createSelector } from 'reselect';
import { RootState } from 'app/AppStore';
import { UploadFileState } from 'components/FileUploadButton/Upload';
import {
  ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_REQUEST,
  ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_REQUEST,
  AscOrderFilterAndSortFieldLocal,
  CHECKOUT_ORDER_REQUEST,
  ClaimForm,
  ClaimsFilterAndSortFieldLocal,
  DATE_FROM,
  DATE_TO,
  FETCH_CLAIMS_REQUEST,
  FETCH_VRN_VEHICLE_INFO_REQUEST,
  FilterKey,
  GET_AFTERSALES_ORDER_LIST_REQUEST,
  GET_CLAIM_DOCUMENT_DOWNLOAD_URL_REQUEST,
  GET_CLAIM_DOCUMENT_UPLOAD_URL_REQUEST,
  GET_CURRENT_DEPOSIT_RETURN_LIST_REQUEST,
  GET_CURRENT_EXADIS_RETURN_LIST_REQUEST,
  GET_EXTERNAL_ORDER_LIST_REQUEST,
  GET_GARAGE_USERS_WITH_ORDER_REQUEST,
  GET_MY_CLIENTS_ORDER_DETAIL_REQUEST,
  GET_MY_CLIENTS_ORDER_LIST_REQUEST,
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_LIST_EXPORT_REQUEST,
  MULTI_ITEMS_DEPOSIT_RETURN,
  MULTI_ITEMS_EXADIS_RETURN,
  MyClientsOrderFilterAndSortFieldLocal,
  ORDER_NAMESPACE,
  ORDER_REMOVE_DEPOSIT_RETURN_LIST_ITEMS_REQUEST,
  ORDER_REMOVE_EXADIS_RETURN_LIST_ITEMS_REQUEST,
  ORDER_SEND_CLAIM_REQUEST,
  OrderItemLocal,
  OrderReferenceItemLocal,
  OrderReturnItem,
  OrderState,
  RE_ADD_ORDER_REFERENCES_TO_BASKET,
  SortKey,
  SortOption,
  SUBSCRIBE_SAP2B_CLAIM_MESSAGES,
  UPDATE_MY_CLIENTS_ORDER_FILTER_AND_REFETCH_LIST,
} from 'domains/order/Order.types';
import { ERROR, FOUND, LOADING, NO_DATA, NOT_FOUND, SEARCH_STATUS, SearchData } from 'utils';

// Init state
const initialState: OrderState = {
  checkoutStatus: null,
  inProgressOrders: {
    orderMap: new Map<string, SearchData<OrderItemLocal>>(),
    orderIds: {
      searchStatus: undefined,
    },
    isLoading: false,
    removeOldData: false,
    cursor: undefined,
    hasMore: true,
    sort: undefined,
    filters: new Map<SortKey, FilterBy<FilterAndSortField>>(),
    activeFilters: new Map<FilterKey, string[]>(),
    pendingOrderIdsToReAddToBasket: [],
  },
  externalOrders: {
    orders: undefined,
  },
  claims: {
    sendClaimStatus: undefined,
    claimForm: {
      formType: undefined,
      orderNumber: '',
      invoiceNumber: '',
      referenceNumberOrdered: '',
      quantityClaimed: 0,
      invoiceLineNumber: undefined,
      reason: '',
      attachments: [],
      soldToPartyId: '',
      shipToPartyId: '',
      vehicle: { vrn: '' },
      labour: { isFitted: true },
    },
    loadedClaims: {
      searchStatus: undefined,
    },
    uploadAttachments: new Map<string, UploadFileState>(),
    filters: new Map<ClaimsFilterAndSortFieldLocal, string | string[]>(),
    downloadingAttachmentIds: new Set<string>(),
    isVrnSearchLoading: false,
    exadisReturnClaimLineKeys: [],
    depositReturnClaimLineKeys: [],
  },
  ascOrders: {
    orders: {
      searchStatus: undefined,
    },
    filters: new Map<AscOrderFilterAndSortField, string>(),
  },
  exadisReturnList: {
    returnList: {
      searchStatus: undefined,
      data: undefined,
    },
    addItemStatus: undefined,
  },
  depositReturnList: {
    returnList: {
      searchStatus: undefined,
      data: undefined,
    },
    addItemStatus: undefined,
  },
  garageUsersWithOrder: [],
  myClientsOrders: {
    orders: {
      searchStatus: undefined,
    },
    selectedOrder: {
      searchStatus: undefined,
    },
    filters: new Map<MyClientsOrderFilterAndSortFieldLocal, string>(),
    pagination: { pageSize: 50, page: 1 },
  },
};

// Saga actions
export const checkoutOrderRequestSaga = createAction<{
  referencesByVehicles: CheckoutVehicleReference[];
  referencesByExternalBasket: CheckoutExternalBasketReference[];
  checkoutOtherSection: CheckoutOtherSection;
  deliveryType: OrderDeliveryType;
  paymentClientCode: string;
}>(CHECKOUT_ORDER_REQUEST);
export const checkoutOrderResponseSaga = createAction(CHECKOUT_ORDER_RESPONSE);
export const downloadDealerOrdersRequestSaga = createAction(GET_ORDER_LIST_EXPORT_REQUEST);
export const fetchDealerOrdersResponseSaga = createAction(GET_ORDER_LIST_RESPONSE);
export const fetchOrderByIdRequestSaga = createAction<string>(GET_ORDER_BY_ID_REQUEST);
export const fetchOrderByIdResponseSaga = createAction(GET_ORDER_BY_ID_RESPONSE);
export const reAddOrderReferencesToBasketRequestSaga = createAction<string>(RE_ADD_ORDER_REFERENCES_TO_BASKET);
export const reAddOrderReferencesToBasketResponseSaga = createAction(RE_ADD_ORDERED_REFERENCES_TO_BASKET_RESPONSE);
export const fetchDealerExternalOrdersRequestSaga = createAction(GET_EXTERNAL_ORDER_LIST_REQUEST);
export const fetchDealerExternalOrdersResponseSaga = createAction(GET_EXTERNAL_ORDER_LIST_RESPONSE);
export const subscribeSap2bClaimMessages = createAction(SUBSCRIBE_SAP2B_CLAIM_MESSAGES);
export const requestClaimResponseSaga = createAction(REQUEST_CLAIM_RESPONSE);
export const subscribeSap2bClaimMessagesResponse = createAction(SEND_CLAIM_RESPONSE);
export const sendOrderClaimRequestSaga = createAction(ORDER_SEND_CLAIM_REQUEST);
export const fetchClaimsRequestSaga = createAction<{ cursor?: string }>(FETCH_CLAIMS_REQUEST);
export const fetchClaimsResponseSaga = createAction(GET_GARAGE_CLAIM_RESPONSE);
export const fetchAscOrdersRequestSaga = createAction<{ cursor?: string }>(GET_AFTERSALES_ORDER_LIST_REQUEST);
export const fetchAscOrdersResponseSaga = createAction(GET_AFTERSALES_ORDER_LIST_RESPONSE);
export const fetchClaimDocumentUploadUrlRequestSaga = createAction<{ fileName: string }>(
  GET_CLAIM_DOCUMENT_UPLOAD_URL_REQUEST,
);
export const fetchClaimDocumentDownloadUrlRequestSaga = createAction<{
  fileName: string;
  fileKey?: string;
  fileUrl?: string;
}>(GET_CLAIM_DOCUMENT_DOWNLOAD_URL_REQUEST);
export const fetchClaimDocumentUploadUrlResponseSaga = createAction(GET_CLAIM_ATTACHMENT_UPLOAD_URL_RESPONSE);
export const fetchClaimDocumentDownloadUrlResponseSaga = createAction(GET_CLAIM_ATTACHMENT_DOWNLOAD_URL_RESPONSE);
export const getGarageUsersWithOrderRequestSaga = createAction(GET_GARAGE_USERS_WITH_ORDER_REQUEST);
export const getGarageUsersWithOrderResponseSaga = createAction(GET_GARAGE_USERS_WITH_ORDER_RESPONSE);
export const fetchMyClientsOrdersRequestSaga = createAction<{ page?: number; pageSize?: number }>(
  GET_MY_CLIENTS_ORDER_LIST_REQUEST,
);
export const fetchMyClientsOrdersResponseSaga = createAction(GET_MY_CLIENTS_ORDER_LIST_RESPONSE);
export const fetchMyClientsOrderDetailRequestSaga = createAction<{ orderNumber: string }>(
  GET_MY_CLIENTS_ORDER_DETAIL_REQUEST,
);
export const fetchMyClientsOrderDetailResponseSaga = createAction(GET_MY_CLIENTS_ORDER_DETAIL_RESPONSE);

export const addExadisReturnListItemRequestSaga = createAction<AddAscOrderItemToExadisReturnListRequest>(
  ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_REQUEST,
);
export const addExadisReturnListItemResponseSaga = createAction(ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_RESPONSE);
export const fetchExadisReturnListRequestSaga = createAction(GET_CURRENT_EXADIS_RETURN_LIST_REQUEST);
export const fetchExadisReturnListResponseSaga = createAction(GET_CURRENT_EXADIS_RETURN_LIST_RESPONSE);
export const removeExadisReturnListItemsRequestSaga = createAction<{ lineKeys: string[] }>(
  ORDER_REMOVE_EXADIS_RETURN_LIST_ITEMS_REQUEST,
);
export const removeExadisReturnListItemsResponseSaga = createAction<
  WsResponse<RemoveItemsFromExadisReturnListResponse>
>(REMOVE_ITEMS_FROM_EXADIS_RETURN_LIST_RESPONSE);

// ExadisReturnList actions are exported as slice actions

export const addDepositReturnListItemRequestSaga = createAction<AddAscOrderItemToDepositReturnListRequest>(
  ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_REQUEST,
);
export const addDepositReturnListItemResponseSaga = createAction(ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_RESPONSE);
export const fetchDepositReturnListRequestSaga = createAction(GET_CURRENT_DEPOSIT_RETURN_LIST_REQUEST);
export const fetchDepositReturnListResponseSaga = createAction(GET_CURRENT_DEPOSIT_RETURN_LIST_RESPONSE);
export const removeDepositReturnListItemsRequestSaga = createAction<{ lineKeys: string[] }>(
  ORDER_REMOVE_DEPOSIT_RETURN_LIST_ITEMS_REQUEST,
);
export const removeDepositReturnListItemsResponseSaga = createAction<
  WsResponse<RemoveItemsFromDepositReturnListResponse>
>(REMOVE_ITEMS_FROM_DEPOSIT_RETURN_LIST_RESPONSE);

// DepositReturnList actions are exported as slice actions
export const updateMyClientsOrdersFiltersAndRefetchSaga = createAction<{
  field: MyClientsOrderFilterAndSortFieldLocal;
  value: string;
}>(UPDATE_MY_CLIENTS_ORDER_FILTER_AND_REFETCH_LIST);

export const orderSubscriptionSaga = createAction<{ loadMore?: boolean } | undefined>(
  `${ORDER_NAMESPACE}/SUBSCRIBE_ORDER_STATUS_UPDATES_REQUEST`,
);
export const orderUnsubscribeSaga = createAction(`${ORDER_NAMESPACE}/UNSUBSCRIBE_ORDER_STATUS_UPDATES_REQUEST`);
export const orderStatusUpdateResponseSaga = createAction<OrderStatusUpdateResponse>(ORDER_STATUS_UPDATE_RESPONSE);
export const fetchVehicleInfoForClaimByVrnRequestSaga = createAction<{ vrn: string }>(FETCH_VRN_VEHICLE_INFO_REQUEST);
export const fetchVehicleInfoForClaimByVrnResponseSaga = createAction(GET_VEHICLE_INFO_BY_VRN_RESPONSE);
export const fetchVehicleInfoByVrnErrorSaga = createAction(GET_VEHICLE_INFO_BY_VRN_ERROR);

export const buildExadisReturnListLineKey = (line: {
  salesOrderNumber?: string;
  invoiceId?: string;
  invoiceLineNumber?: number;
  reference?: string;
}): string =>
  [line.salesOrderNumber ?? '', line.invoiceId ?? '', line.invoiceLineNumber ?? '', line.reference ?? ''].join('|');

export const buildDepositReturnListLineKey = (line: {
  salesOrderNumber?: string;
  invoiceId?: string;
  invoiceLineNumber?: number;
  reference?: string;
}): string =>
  [line.salesOrderNumber ?? '', line.invoiceId ?? '', line.invoiceLineNumber ?? '', line.reference ?? ''].join('|');

const mapToLocalOrder = (orderItem: OrderItem): OrderItemLocal => {
  return {
    ...orderItem,
    orderedReferences: orderItem.orderedReferences.map((orderRef) => ({
      ...orderRef,
      requestReason: undefined,
      qtyToReturn: 0,
      substitutes: orderRef.substitutes?.map((substituteRef) => ({
        ...substituteRef,
        requestReason: undefined,
        qtyToReturn: 0,
      })),
    })),
  };
};

const isOtherAscFilterKey = (key: AscOrderFilterAndSortFieldLocal): boolean => key !== DATE_FROM && key !== DATE_TO;

const applyDefaultCdeItAscDateRange = (filters: Map<AscOrderFilterAndSortFieldLocal, string>): void => {
  filters.set(DATE_FROM, moment().startOf('day').subtract(1, 'day').format());
  filters.set(DATE_TO, moment().startOf('day').format());
};

const slice = createSlice({
  name: ORDER_NAMESPACE,
  initialState,
  reducers: {
    setInitialState: () => initialState,
    setCheckoutStatus: (
      state,
      action: PayloadAction<{
        placedOrders: OrderCheckoutResult[];
        failedOrders: OrderCheckoutResult[];
        ordersOverallStatus: CheckoutOverallStatus;
      }>,
    ) => {
      const { placedOrders, failedOrders, ordersOverallStatus } = action.payload;
      state.checkoutStatus = {
        placedOrders,
        failedOrders,
        ordersOverallStatus,
      };
    },
    clearCheckoutStatus: (state) => {
      state.checkoutStatus = null;
    },
    setInProgressOrdersNotFound: (state, { payload }: PayloadAction<typeof ERROR | typeof NOT_FOUND | undefined>) => {
      state.inProgressOrders.orderIds = {
        searchStatus: payload,
        data: undefined,
      };
      state.inProgressOrders.hasMore = false;
      state.inProgressOrders.isLoading = false;
    },
    addInProgressOrdersData: (
      state,
      action: PayloadAction<{ orderItems: OrderItem[]; cursor: string; hasMore: boolean }>,
    ) => {
      const { orderItems, cursor, hasMore } = action.payload;

      const currOrderIds = state.inProgressOrders.removeOldData ? [] : state.inProgressOrders.orderIds?.data ?? [];
      orderItems.forEach((o) => {
        state.inProgressOrders.orderMap.set(o.internalOrderId, { searchStatus: FOUND, data: mapToLocalOrder(o) });
      });
      const newIds = orderItems.map((o) => o.internalOrderId);
      const existingIdSet = new Set(currOrderIds);
      const mergedIds = currOrderIds.concat(newIds.filter((id) => !existingIdSet.has(id)));
      state.inProgressOrders.orderIds = {
        searchStatus: FOUND,
        data: mergedIds,
      };
      state.inProgressOrders.hasMore = hasMore;
      state.inProgressOrders.cursor = cursor;
      state.inProgressOrders.removeOldData = false;
    },
    addInProgressOrder: (state, action: PayloadAction<OrderItem>) => {
      const orderItem = action.payload;
      state.inProgressOrders.orderMap.set(orderItem.internalOrderId, {
        searchStatus: FOUND,
        data: mapToLocalOrder(orderItem),
      });
    },
    updateOrderStatus: (state, action: PayloadAction<OrderStatusUpdateResponse>) => {
      const { orderId, orderStatus, presentableOrderStatus, referenceStatuses } = action.payload;

      if (presentableOrderStatus === 'HIDDEN') {
        state.inProgressOrders.orderMap.delete(orderId);
        if (state.inProgressOrders.orderIds.data) {
          state.inProgressOrders.orderIds.data = state.inProgressOrders.orderIds.data.filter((id) => id !== orderId);
        }
        return;
      }

      const orderData = state.inProgressOrders.orderMap.get(orderId);
      if (!orderData?.data) {
        return;
      }

      orderData.data.orderStatus = orderStatus;
      orderData.data.presentableOrderStatus = presentableOrderStatus;
      if (!referenceStatuses) {
        return;
      }

      for (const refUpdate of referenceStatuses) {
        const ref = orderData.data.orderedReferences.find(
          (r) => r.referenceNumber === refUpdate.referenceNumber && r.sellerNumber === refUpdate.sellerNumber,
        );
        if (ref) {
          ref.status = refUpdate.status;
        }
      }
    },
    addOrderIdToPendingAddToBasketRequests: (state, action: PayloadAction<string>) => {
      const orderId = action.payload;
      state.inProgressOrders.pendingOrderIdsToReAddToBasket = [
        ...state.inProgressOrders.pendingOrderIdsToReAddToBasket,
        orderId,
      ];
    },
    removeOrderIdFromPendingAddToBasketRequests: (state, action: PayloadAction<string>) => {
      const orderId = action.payload;
      state.inProgressOrders.pendingOrderIdsToReAddToBasket = state.inProgressOrders.pendingOrderIdsToReAddToBasket.filter(
        (id) => id !== orderId,
      );
    },
    setInProgressOrderSearchStatus: (
      state,
      action: PayloadAction<{ orderId: string; status: typeof LOADING | typeof NOT_FOUND | typeof ERROR }>,
    ) => {
      const { orderId, status } = action.payload;
      state.inProgressOrders.orderMap.set(orderId, {
        searchStatus: status,
      });
    },
    resetInProgressOrdersForNewSearch: (state) => {
      state.inProgressOrders.orderIds = {
        searchStatus: undefined,
        data: undefined,
      };
      state.inProgressOrders.removeOldData = true;
      state.inProgressOrders.hasMore = true;
      state.inProgressOrders.cursor = undefined;
    },
    setActiveFilters: (state) => {
      const startDate = state.inProgressOrders.filters.get('START_DATE');
      const endDate = state.inProgressOrders.filters.get('END_DATE');
      [...state.inProgressOrders.filters.entries()]
        .filter(([key, _]) => key !== 'START_DATE' && key !== 'END_DATE')
        .forEach(([key, value]) => {
          state.inProgressOrders.activeFilters.set(key as FilterKey, [value.value]);
        });
      if (startDate && endDate) {
        state.inProgressOrders.activeFilters.set('DATE', [startDate.value, endDate.value]);
      }
    },
    setInProgressOrdersFilter: (
      state,
      { payload }: PayloadAction<{ filter: FilterBy<FilterAndSortField>; key: SortKey }>,
    ) => {
      state.inProgressOrders.filters.set(payload.key, payload.filter);
    },
    resetInProgressOrdersFilter: (state, { payload }: PayloadAction<{ key: FilterKey; statusValue?: string }>) => {
      if (payload.key === 'STATUS') {
        const status = state.inProgressOrders.filters.get('STATUS');
        if (!status || !payload.statusValue) {
          return;
        }

        const statusArray = status.value.split('-').filter((elem) => elem !== payload.statusValue);

        const newStatusValue = statusArray.join('-');
        const modifiedStatus: FilterBy<FilterAndSortField> = new FilterBy<FilterAndSortField>(
          'STATUS',
          newStatusValue,
          'IN',
        );

        state.inProgressOrders.filters.set('STATUS', modifiedStatus);
        state.inProgressOrders.activeFilters.set('STATUS', [newStatusValue]);
        return;
      }
      state.inProgressOrders.activeFilters.delete(payload.key);
      if (payload.key === 'DATE') {
        state.inProgressOrders.filters.delete('START_DATE');
        state.inProgressOrders.filters.delete('END_DATE');
        return;
      }
      state.inProgressOrders.filters.delete(payload.key);
    },
    resetInProgressOrdersFilters: (state) => {
      state.inProgressOrders.filters.clear();
      state.inProgressOrders.activeFilters.clear();
    },
    setInProgressOrdersSort: (state, { payload }: PayloadAction<SortOption>) => {
      state.inProgressOrders.sort = payload;
    },
    setInProgressIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.inProgressOrders.isLoading = payload;
    },
    setExternalOrdersNoDataStatus: (state, { payload }: PayloadAction<NO_DATA>) => {
      state.externalOrders.orders = payload;
    },
    addExternalOrdersData: (state, action: PayloadAction<ExternalOrderItem[]>) => {
      state.externalOrders.orders = action.payload;
    },
    initOrderClaimForm: (state) => {
      state.claims.uploadAttachments = new Map<string, UploadFileState>();
      state.claims.exadisReturnClaimLineKeys = [];
      state.claims.depositReturnClaimLineKeys = [];
      state.claims.claimForm = initialState.claims.claimForm;
    },
    initExadisReturnClaimForm: (state, { payload }: PayloadAction<{ claimItems: ClaimItem[]; lineKeys: string[] }>) => {
      state.claims.uploadAttachments = new Map<string, UploadFileState>();
      state.claims.exadisReturnClaimLineKeys = payload.lineKeys;
      state.claims.claimForm = {
        ...initialState.claims.claimForm,
        formType: MULTI_ITEMS_EXADIS_RETURN,
        reason: 'Y09',
        orderNumber: '',
        invoiceNumber: '',
        message: '',
        attachments: [],
        claimItems: payload.claimItems,
      };
    },
    initDepositReturnClaimForm: (
      state,
      { payload }: PayloadAction<{ claimItems: ClaimItem[]; lineKeys: string[] }>,
    ) => {
      state.claims.uploadAttachments = new Map<string, UploadFileState>();
      state.claims.depositReturnClaimLineKeys = payload.lineKeys;
      state.claims.claimForm = {
        ...initialState.claims.claimForm,
        formType: MULTI_ITEMS_DEPOSIT_RETURN,
        reason: 'Y9A',
        orderNumber: '',
        invoiceNumber: '',
        message: '',
        attachments: [],
        claimItems: payload.claimItems,
      };
    },
    setOrderClaimForm: (state, action: PayloadAction<ClaimForm>) => {
      state.claims.claimForm = action.payload;
    },
    clearClaimVehicleInfo: (state) => {
      state.claims.claimForm = {
        ...state.claims.claimForm,
        vehicle: { vrn: state.claims.claimForm.vehicle?.vrn || '' },
      };
    },
    setVrnSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.claims.isVrnSearchLoading = action.payload;
    },
    setOrderClaimStatus: (state, action: PayloadAction<SEARCH_STATUS>) => {
      state.claims.sendClaimStatus = action.payload;
    },
    setOrderClaimAttachmentDownloading: (state, action: PayloadAction<string>) => {
      state.claims.downloadingAttachmentIds.add(action.payload);
    },
    clearOrderClaimAttachmentDownloading: (state, action: PayloadAction<string>) => {
      state.claims.downloadingAttachmentIds.delete(action.payload);
    },
    setGarageUsersWithOrder: (state, action: PayloadAction<UserWithOrder[]>) => {
      state.garageUsersWithOrder = action.payload;
    },
    resetReturnRequest: (state, { payload }: PayloadAction<string>) => {
      const order = state.inProgressOrders.orderMap.get(payload)?.data;
      if (order === undefined) {
        return;
      }

      const resetReferences = order.orderedReferences.map((ref) => ({
        ...ref,
        substitutes: ref.substitutes?.map((substitutedRef) => ({
          ...substitutedRef,
          requestReason: undefined,
          qtyToReturn: 0,
        })),
        requestReason: undefined,
        qtyToReturn: 0,
      }));

      state.inProgressOrders.orderMap.set(order.internalOrderId, {
        searchStatus: FOUND,
        data: { ...order, orderedReferences: resetReferences },
      });
    },
    updateReturnRequest: (
      state,
      { payload }: PayloadAction<{ index: number; orderId: string; reference: OrderReferenceItemLocal }>,
    ) => {
      const { index, orderId, reference } = payload;

      const order = state.inProgressOrders.orderMap.get(orderId)?.data;
      if (order === undefined) {
        return;
      }

      const updatedReferences = [...order.orderedReferences];
      updatedReferences[index] = reference;

      state.inProgressOrders.orderMap.set(order.internalOrderId, {
        searchStatus: FOUND,
        data: { ...order, orderedReferences: updatedReferences },
      });
    },
    resetLoadedClaims: (state) => {
      state.claims.loadedClaims.data = initialState.claims.loadedClaims.data;
    },
    setLoadedClaims: (state, { payload }: PayloadAction<GetGarageClaimPageResponse>) => {
      const { claims } = payload;
      const claimsArray = state.claims.loadedClaims.data?.claims ?? [];
      claims?.forEach((claim) => {
        claimsArray.push(claim);
      });
      state.claims.loadedClaims = {
        searchStatus: FOUND,
        data: {
          ...payload,
          claims: claimsArray,
        },
      };
    },
    setLoadedClaimsSearchStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.claims.loadedClaims.searchStatus = payload;
    },
    updateReturnedReferenceQty: (
      state,
      { payload }: PayloadAction<{ orderId: string; references: ReferenceToReturn[] }>,
    ) => {
      const { orderId, references } = payload;

      const order = state.inProgressOrders.orderMap.get(orderId)?.data;
      if (order === undefined) {
        return;
      }

      const updatedReferences = [...order.orderedReferences];

      references.forEach((ref) => {
        if (!ref.parentReference) {
          const index = updatedReferences.findIndex(
            (r) => r.referenceNumber === ref.referenceNumber && r.sellerNumber === ref.sellerNumber,
          );
          if (index !== -1) {
            updatedReferences[index] = {
              ...updatedReferences[index],
              returnedQuantity: (updatedReferences[index].returnedQuantity ?? 0) + (ref.returnedQuantity ?? 0),
            };
          }
          return;
        }

        const parentIndex = updatedReferences.findIndex(
          (r) => r.referenceNumber === ref.parentReference && r.sellerNumber === ref.sellerNumber,
        );
        if (parentIndex !== -1) {
          const parentRef = updatedReferences[parentIndex];

          if (!parentRef?.substitutes) {
            return;
          }
          const substitutedIndex = parentRef.substitutes.findIndex((r) => r.referenceNumber === ref.referenceNumber);
          if (substitutedIndex !== -1) {
            parentRef.substitutes[substitutedIndex] = {
              ...parentRef.substitutes[substitutedIndex],
              returnedQuantity:
                (parentRef.substitutes[substitutedIndex].returnedQuantity ?? 0) + (ref.returnedQuantity ?? 0),
            };
          }
        }
      });
      state.inProgressOrders.orderMap.set(order.internalOrderId, {
        searchStatus: FOUND,
        data: { ...order, orderedReferences: updatedReferences },
      });
    },
    setAscOrders: (state, { payload }: PayloadAction<AftersalesOrderResponse>) => {
      const { orders } = payload;
      const oldOrders = state.ascOrders.orders.data?.orders ?? [];
      state.ascOrders.orders = {
        searchStatus: FOUND,
        data: { ...payload, orders: oldOrders.concat(orders) },
      };
    },
    resetAscOrders: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.ascOrders.orders = { ...initialState.ascOrders.orders, searchStatus: payload };
    },
    setAscOrdersStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.ascOrders.orders = {
        ...state.ascOrders.orders,
        searchStatus: payload,
      };
    },
    setMyClientsOrders: (state, { payload }: PayloadAction<MyClientsOrderResponse>) => {
      state.myClientsOrders.orders = {
        searchStatus: FOUND,
        data: payload,
      };
    },
    setMyClientsOrderDetail: (state, { payload }: PayloadAction<MyClientsOrderDetailResponse>) => {
      state.myClientsOrders.selectedOrder = {
        searchStatus: FOUND,
        data: payload,
      };
    },
    setMyClientsOrderDetailStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.myClientsOrders.selectedOrder = {
        ...state.myClientsOrders.selectedOrder,
        searchStatus: payload,
      };
    },
    resetMyClientsOrderDetail: (state) => {
      state.myClientsOrders.selectedOrder = initialState.myClientsOrders.selectedOrder;
    },
    setMyClientsOrdersPagination: (state, { payload }: PayloadAction<{ pageSize: number; page: number }>) => {
      state.myClientsOrders.pagination = payload;
    },
    resetMyClientsOrders: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.myClientsOrders.orders = { ...initialState.myClientsOrders.orders, searchStatus: payload };
    },
    setMyClientsOrdersStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.myClientsOrders.orders = {
        ...state.myClientsOrders.orders,
        searchStatus: payload,
      };
    },
    setExadisReturnList: (state, { payload }: PayloadAction<SearchData<ExadisReturnListLine[]>>) => {
      state.exadisReturnList.returnList = payload;
    },
    setExadisReturnListStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.exadisReturnList.returnList = {
        ...state.exadisReturnList.returnList,
        searchStatus: payload,
      };
    },
    addExadisReturnListItem: (state, { payload }: PayloadAction<ExadisReturnListLine>) => {
      const currentItems = state.exadisReturnList.returnList?.data ?? [];
      const payloadKey = buildExadisReturnListLineKey(payload);
      const itemsWithoutDuplicate = currentItems.filter((item) => buildExadisReturnListLineKey(item) !== payloadKey);
      state.exadisReturnList.returnList = {
        searchStatus: FOUND,
        data: [...itemsWithoutDuplicate, payload],
      };
    },
    setExadisReturnListAddItemStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.exadisReturnList.addItemStatus = payload;
    },
    setDepositReturnList: (state, { payload }: PayloadAction<SearchData<DepositReturnListLine[]>>) => {
      state.depositReturnList.returnList = payload;
    },
    setDepositReturnListStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.depositReturnList.returnList = {
        ...state.depositReturnList.returnList,
        searchStatus: payload,
      };
    },
    addDepositReturnListItem: (state, { payload }: PayloadAction<DepositReturnListLine>) => {
      const currentItems = state.depositReturnList.returnList?.data ?? [];
      const payloadKey = buildDepositReturnListLineKey(payload);
      const itemsWithoutDuplicate = currentItems.filter((item) => buildDepositReturnListLineKey(item) !== payloadKey);
      state.depositReturnList.returnList = {
        searchStatus: FOUND,
        data: [...itemsWithoutDuplicate, payload],
      };
    },
    setDepositReturnListAddItemStatus: (state, { payload }: PayloadAction<SEARCH_STATUS>) => {
      state.depositReturnList.addItemStatus = payload;
    },
    addClaimUploadAttachment: (state, { payload }: PayloadAction<UploadFileState>) => {
      const { fileName } = payload;
      state.claims.uploadAttachments.set(fileName, payload);
    },
    removeClaimUploadAttachment: (state, { payload }: PayloadAction<string>) => {
      state.claims.uploadAttachments.delete(payload);
    },
    setAscOrdersFilter: (
      state,
      { payload }: PayloadAction<{ field: AscOrderFilterAndSortFieldLocal; value?: string }>,
    ) => {
      const { field, value } = payload;
      const filters = state.ascOrders.filters;
      if (value && value.length > 0) {
        filters.set(field, value);
      } else {
        filters.delete(field);
      }
    },
    resetAscOrdersFilter: (state) => {
      state.ascOrders.filters = initialState.ascOrders.filters;
    },
    resetCdeItAscOrdersFilter: (state) => {
      const filters = state.ascOrders.filters;
      filters.clear();
      applyDefaultCdeItAscDateRange(filters);
    },
    setCdeItAscOrdersFilter: (
      state,
      { payload }: PayloadAction<{ field: AscOrderFilterAndSortFieldLocal; value?: string }>,
    ) => {
      const { field, value } = payload;
      const filters = state.ascOrders.filters;
      const hasOtherFilters = [...filters.keys()].some(isOtherAscFilterKey);

      if (field === DATE_FROM || field === DATE_TO) {
        if (hasOtherFilters) {
          return;
        }
        if (value && value.length > 0) {
          filters.set(field, value);
        }
        return;
      }

      if (value && value.length > 0) {
        filters.delete(DATE_FROM);
        filters.delete(DATE_TO);
        filters.set(field, value);
      } else {
        filters.delete(field);
        if (![...filters.keys()].some(isOtherAscFilterKey)) {
          applyDefaultCdeItAscDateRange(filters);
        }
      }
    },
    setClaimsFilter: (
      state,
      { payload }: PayloadAction<{ field: ClaimsFilterAndSortFieldLocal; value?: string | string[] }>,
    ) => {
      const { field, value } = payload;
      const filters = state.claims.filters;
      if (value && value.length > 0) {
        filters.set(field, value);
      } else {
        filters.delete(field);
      }
    },
    resetClaimsFilter: (state) => {
      state.claims.filters = initialState.claims.filters;
    },
    setMyClientsOrdersFilter: (
      state,
      { payload }: PayloadAction<{ field: MyClientsOrderFilterAndSortFieldLocal; value?: string }>,
    ) => {
      const { field, value } = payload;
      const filters = state.myClientsOrders.filters;
      if (value && value.length > 0) {
        filters.set(field, value);
      } else {
        filters.delete(field);
      }
    },
    resetMyClientsOrdersFilter: (state) => {
      state.myClientsOrders.filters = initialState.myClientsOrders.filters;
    },
    resetOrderSubscriptionStatus: (state) => {
      state.inProgressOrders.orderIds = { searchStatus: undefined, data: undefined };
      state.inProgressOrders.hasMore = true;
      state.inProgressOrders.cursor = undefined;
      state.inProgressOrders.removeOldData = false;
    },
  },
});

// Actions
export const {
  setInitialState,
  setCheckoutStatus,
  clearCheckoutStatus,
  setInProgressOrdersNotFound,
  addInProgressOrdersData,
  addInProgressOrder,
  updateOrderStatus,
  setInProgressOrderSearchStatus,
  resetInProgressOrdersForNewSearch,
  setActiveFilters,
  setInProgressOrdersFilter,
  resetInProgressOrdersFilter,
  resetInProgressOrdersFilters,
  setInProgressOrdersSort,
  setInProgressIsLoading,
  addExternalOrdersData,
  setExternalOrdersNoDataStatus,
  resetReturnRequest,
  updateReturnRequest,
  updateReturnedReferenceQty,
  addOrderIdToPendingAddToBasketRequests,
  removeOrderIdFromPendingAddToBasketRequests,
  setOrderClaimForm,
  setOrderClaimStatus,
  clearClaimVehicleInfo,
  setVrnSearchLoading,
  setLoadedClaims,
  setLoadedClaimsSearchStatus,
  resetLoadedClaims,
  setAscOrders,
  resetAscOrders,
  setAscOrdersStatus,
  setAscOrdersFilter,
  setMyClientsOrders,
  setMyClientsOrdersPagination,
  resetMyClientsOrders,
  setMyClientsOrdersStatus,
  setMyClientsOrdersFilter,
  resetMyClientsOrdersFilter,
  setMyClientsOrderDetail,
  setMyClientsOrderDetailStatus,
  resetMyClientsOrderDetail,
  addClaimUploadAttachment,
  removeClaimUploadAttachment,
  setClaimsFilter,
  resetAscOrdersFilter,
  initOrderClaimForm,
  initExadisReturnClaimForm,
  initDepositReturnClaimForm,
  resetClaimsFilter,
  setGarageUsersWithOrder,
  setOrderClaimAttachmentDownloading,
  clearOrderClaimAttachmentDownloading,
  resetCdeItAscOrdersFilter,
  setCdeItAscOrdersFilter,
  resetOrderSubscriptionStatus,
  setExadisReturnList,
  setExadisReturnListStatus,
  addExadisReturnListItem,
  setExadisReturnListAddItemStatus,
  setDepositReturnList,
  setDepositReturnListStatus,
  addDepositReturnListItem,
  setDepositReturnListAddItemStatus,
} = slice.actions;

// Getters/Selectors
export const getCheckoutStatus = createSelector(
  (state: RootState) => state.order.checkoutStatus,
  (checkoutStatus) => checkoutStatus,
);

export const getInProgressOrderIdsData = createSelector(
  (state: RootState) => state.order.inProgressOrders.orderIds,
  (orders) => orders?.data ?? [],
);

export const getInProgressOrder = createSelector(
  (state: RootState) => state.order.inProgressOrders.orderMap,
  (_state: RootState, orderId: string) => orderId,
  (orderMap, orderId) => orderMap.get(orderId),
);

export const getInProgressOrders = createSelector(
  (state: RootState) => state.order.inProgressOrders.orderMap,
  (_state: RootState, orderIds: string[]) => orderIds,
  (orderMap, orderIds) =>
    orderIds.map((orderId) => orderMap.get(orderId)?.data).filter((o): o is OrderItemLocal => o !== undefined),
);

export const getInProgressOrdersCursor = createSelector(
  (state: RootState) => state.order.inProgressOrders.cursor,
  (cursor) => cursor,
);

export const getInProgressOrdersHasMore = createSelector(
  (state: RootState) => state.order.inProgressOrders.hasMore,
  (hasMore) => hasMore,
);

export const getAllInProgressOrdersFilters = createSelector(
  (state: RootState) => state.order.inProgressOrders.filters,
  (filters) => [...filters.values()].filter((f) => f.value.length !== 0),
);

export const getActiveFilters = createSelector(
  (state: RootState) => state.order.inProgressOrders.activeFilters,
  (filters) => Array.from(filters).filter(([_, value]) => value.length !== 0 && value[0].length !== 0),
);

export const getInProgressOrdersIsLoading = createSelector(
  (state: RootState) => state.order.inProgressOrders.isLoading,
  (isLoading) => isLoading,
);

export const getInProgressOrdersFilter = createSelector(
  (state: RootState) => state.order.inProgressOrders.filters,
  (_state: RootState, field: SortKey) => field,
  (filters, field) => filters.get(field),
);

export const getInProgressOrdersSort = createSelector(
  (state: RootState) => state.order.inProgressOrders.sort,
  (sort) => sort,
);

export const getExternalOrders = createSelector(
  (state: RootState) => state.order.externalOrders.orders,
  (orders) => orders,
);

export const getOrderClaimForm = createSelector(
  (state: RootState) => state.order.claims.claimForm,
  (claimForm) => claimForm,
);

export const getExadisReturnClaimLineKeys = createSelector(
  (state: RootState) => state.order.claims.exadisReturnClaimLineKeys,
  (keys) => keys,
);

export const getDepositReturnClaimLineKeys = createSelector(
  (state: RootState) => state.order.claims.depositReturnClaimLineKeys,
  (keys) => keys,
);

export const getLoadedClaims = createSelector(
  (state: RootState) => state.order.claims.loadedClaims,
  (loadedClaims) => loadedClaims,
);

export const getOrderClaimStatus = createSelector(
  (state: RootState) => state.order.claims.sendClaimStatus,
  (sendClaimStatus) => sendClaimStatus,
);

export const getIsVrnSearchLoading = createSelector(
  (state: RootState) => state.order.claims.isVrnSearchLoading,
  (isVrnSearchLoading) => isVrnSearchLoading,
);

export const getOrderClaimDownloadingAttachmentIds = createSelector(
  (state: RootState) => state.order.claims.downloadingAttachmentIds,
  (downloadingAttachmentIds) => downloadingAttachmentIds,
);

export const getGarageUsersWithOrder = createSelector(
  (state: RootState) => state.order.garageUsersWithOrder,
  (garageUsersWithOrder) => garageUsersWithOrder,
);

export const getReferencesToReturn = createSelector(
  (state: RootState) => state.order.inProgressOrders.orderMap,
  (_state: RootState, orderId: string) => orderId,
  (orderMap, orderId) => {
    const order = orderMap.get(orderId)?.data;
    if (order === undefined) {
      return;
    }

    const referencesToReturn: OrderReturnItem[] = [];

    order.orderedReferences.forEach((orderedRef, index) => {
      if (orderedRef.requestReason && orderedRef.qtyToReturn) {
        referencesToReturn.push({
          index,
          referenceNumber: orderedRef.referenceNumber,
          name: orderedRef.name,
          brand: orderedRef.brand,
          qtyToReturn: orderedRef.qtyToReturn,
          supplier: orderedRef.supplier,
          requestReason: orderedRef.requestReason,
        });
      }
      orderedRef.substitutes?.forEach((substitutedRef, index) => {
        if (substitutedRef.requestReason && substitutedRef.qtyToReturn) {
          referencesToReturn.push({
            index,
            referenceNumber: substitutedRef.referenceNumber,
            parentReferenceNumber: orderedRef.referenceNumber,
            name: undefined,
            qtyToReturn: substitutedRef.qtyToReturn,
            brand: undefined,
            supplier: undefined,
            requestReason: substitutedRef.requestReason,
          });
        }
      });
    });
    return referencesToReturn;
  },
);

export const isOrderIdInPendingReAddToBasketRequests = createSelector(
  (state: RootState) => state.order.inProgressOrders.pendingOrderIdsToReAddToBasket,
  (_state: RootState, orderId: string) => orderId,
  (array, orderId) => array.includes(orderId),
);

export const getAscOrders = createSelector(
  (state: RootState) => state.order.ascOrders.orders,
  (orders) => orders,
);

export const getAscOrdersFilters = createSelector(
  (state: RootState) => state.order.ascOrders.filters,
  (filters) => filters,
);

export const getHasAscOrderOtherFilters = createSelector([getAscOrdersFilters], (filters) =>
  [...filters.keys()].some(isOtherAscFilterKey),
);

export const getMyClientsOrders = createSelector(
  (state: RootState) => state.order.myClientsOrders.orders,
  (orders) => orders,
);

export const getMyClientsOrderDetail = createSelector(
  (state: RootState) => state.order.myClientsOrders.selectedOrder,
  (selectedOrder) => selectedOrder,
);

export const getMyClientsOrdersPagination = createSelector(
  (state: RootState) => state.order.myClientsOrders.pagination,
  (pagination) => pagination,
);

export const getMyClientsOrdersFilters = createSelector(
  (state: RootState) => state.order.myClientsOrders.filters,
  (filters) => filters,
);

export const getClaimsFilters = createSelector(
  (state: RootState) => state.order.claims.filters,
  (filters) => filters,
);

export const getClaimsUploadAttachments = createSelector(
  (state: RootState) => state.order.claims.uploadAttachments,
  (uploadAttachments) => uploadAttachments,
);
export const getClaimsUploadAttachment = createSelector(
  (state: RootState) => state.order.claims.uploadAttachments,
  (_state: RootState, fileName: string) => fileName,
  (uploadAttachments, fileName) => uploadAttachments.get(fileName),
);

export const getExadisReturnList = createSelector(
  (state: RootState) => state.order.exadisReturnList.returnList,
  (returnList) => returnList,
);

export const getExadisReturnListItems = createSelector([getExadisReturnList], (returnList) => returnList?.data ?? []);

export const getExadisReturnListItemsCount = createSelector([getExadisReturnListItems], (items) => items.length);

export const getExadisReturnListFetchStatus = createSelector(
  (state: RootState) => state.order.exadisReturnList.returnList,
  (returnList) => returnList?.searchStatus,
);

export const getExadisReturnListAddItemStatus = createSelector(
  (state: RootState) => state.order.exadisReturnList.addItemStatus,
  (addItemStatus) => addItemStatus,
);

export const getIsExadisReturnListFull = createSelector([getExadisReturnListItemsCount], (count) => count >= 99);

export const getExadisReturnListItemByKey = createSelector(
  [getExadisReturnListItems, (_state: RootState, key: string) => key],
  (items, key) => items.find((line) => buildExadisReturnListLineKey(line) === key),
);

export const getDepositReturnList = createSelector(
  (state: RootState) => state.order.depositReturnList.returnList,
  (returnList) => returnList,
);

export const getDepositReturnListItems = createSelector([getDepositReturnList], (returnList) => returnList?.data ?? []);

export const getDepositReturnListItemsCount = createSelector([getDepositReturnListItems], (items) => items.length);

export const getDepositReturnListFetchStatus = createSelector(
  (state: RootState) => state.order.depositReturnList.returnList,
  (returnList) => returnList?.searchStatus,
);

export const getDepositReturnListAddItemStatus = createSelector(
  (state: RootState) => state.order.depositReturnList.addItemStatus,
  (addItemStatus) => addItemStatus,
);

export const getIsDepositReturnListFull = createSelector([getDepositReturnListItemsCount], (count) => count >= 99);

export const getDepositReturnListItemByKey = createSelector(
  [getDepositReturnListItems, (_state: RootState, key: string) => key],
  (items, key) => items.find((line) => buildDepositReturnListLineKey(line) === key),
);

// Export reducer
export default slice.reducer;
